import React, { useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { selectPartner } from "../store/partnerStore";
import { PARTNER_KEYS, resolvePartnerSync } from "../utils/partner";
import { v2Tokens } from "../v2/theme/tokens";

const themes = {
  [PARTNER_KEYS.CLALIT]: {
    "--primary-color": "#1B296B",
    "--primary-color-border": "#1B296B",
    "--primary-color-footer": "#97d4f7",
    "--primary-color-footer-text": "#1B296B",
    "--sidebar-color-text": "#FFFFFF",
    "--order-again-button": "#1B296B",
    "--darkblue": "#1B296B",
    "--blue-text-color": "#139deb",
    "--red-text-color": "#D23240",
    "--red-button-color": "#D23240",
    "--red-button-text-color": "#FFFFFF",
    "--dropdown-menu-background": "#1B296B",
    "--dropdown-menu-border": "#1B296B",
    "--dropdown-menu-color": "#FFFFFF",
    "--club-card-background-color": "#F4F9FC",
    "--club-card-price-color": "#139deb",
    "--dropdown-background-color": "#F4F9FC",
    "--dropdown-border-color": "#1B296B",
    "--history-background-color": "#f4f9fc",
    "--scheduled-button-text-color": "#1B296B",
    "--available-room-color": "#f69934",
    "--coach-name-color": "#959594",
    "--dialog-border-radius": "0",
    "--font-family": `"OpenSans", sans-serif`,
  },
  [PARTNER_KEYS.MEHUDET]: {
    "--primary-color": "#009BDF",
    "--primary-color-border": "#0091EA",
    "--primary-color-footer": "#F3F9FE",
    "--primary-color-footer-text": "#FFFFFF",
    "--sidebar-color-text": "#003D62",
    "--order-again-button": "#003D62",
    "--darkblue": "#003D62",
    "--blue-text-color": "#003D62",
    "--red-text-color": "#003D62",
    "--red-button-color": "#CFECFF",
    "--red-button-text-color": "#153899",
    "--dropdown-menu-background": "#F3F9FE",
    "--dropdown-menu-border": "#F0F1F2",
    "--dropdown-menu-color": "#003D62",
    "--club-card-background-color": "#FFFFFF",
    "--club-card-price-color": "#0091EA",
    "--dropdown-background-color": "#FFFFFF",
    "--dropdown-border-color": "#D8D8D8",
    "--history-background-color": "#ffffff",
    "--scheduled-button-text-color": "#153899",
    "--available-room-color": "#0067A6",
    "--coach-name-color": "#003D62",
    "--dialog-border-radius": "24px",
    "--font-family": `Ploni ML v2 AAA`,
  },
  [PARTNER_KEYS.LEUMIT]: {
    "--primary-color": "#8E03A6",
    "--primary-color-border": "#8E03A6",
    "--primary-color-footer": "#8E03A6",
    "--primary-color-footer-text": "#FFFFFF",
    "--sidebar-color-text": "#8E03A6",
    "--order-again-button": "#8E03A6",
    "--darkblue": "#8E03A6",
    "--blue-text-color": "#8E03A6",
    "--red-text-color": "#8E03A6",
    "--red-button-color": "#D4EDDA",
    "--red-button-text-color": "#8E03A6",
    "--dropdown-menu-background": "#F0FAF4",
    "--dropdown-menu-border": "#C3E6CB",
    "--dropdown-menu-color": "#8E03A6",
    "--club-card-background-color": "#F4F8FC",
    "--club-card-price-color": "#8E03A6",
    "--dropdown-background-color": "#FFFFFF",
    "--dropdown-border-color": "#8E03A6",
    "--history-background-color": "#F1F1F1",
    "--scheduled-button-text-color": "#8E03A6",
    "--available-room-color": "#8E03A6",
    "--coach-name-color": "#8E03A6",
    "--dialog-border-radius": "24px",
    "--font-family": `"OpenSans", sans-serif`,
  },
  [PARTNER_KEYS.OVDIM_BARI]: {
    "--primary-color": "#3946C0",
    "--primary-color-border": "#3946C0",
    "--primary-color-footer": "#3946C0",
    "--primary-color-footer-text": "#FFFFFF",
    "--sidebar-color-text": "#FFFFFF",
    "--order-again-button": "#3946C0",
    "--darkblue": "#3946C0",
    "--blue-text-color": "#3946C0",
    "--red-text-color": "#D23240",
    "--red-button-color": "#D23240",
    "--red-button-text-color": "#FFFFFF",
    "--dropdown-menu-background": "#3946C0",
    "--dropdown-menu-border": "#3946C0",
    "--dropdown-menu-color": "#FFFFFF",
    "--club-card-background-color": "#F4F9FC",
    "--club-card-price-color": "#3946C0",
    "--dropdown-background-color": "#F4F9FC",
    "--dropdown-border-color": "#3946C0",
    "--history-background-color": "#F4F9FC",
    "--scheduled-button-text-color": "#3946C0",
    "--available-room-color": "#f69934",
    "--coach-name-color": "#959594",
    "--dialog-border-radius": "0",
    "--font-family": `"OpenSans", sans-serif`,
  },
  [PARTNER_KEYS.MAOFLAAMIT]: {
    "--blue-btn-bg": "#F7941D",
    "--primary-color": "#F7941D",
    "--primary-color-border": "#000000",
    "--primary-color-footer": "#F7941D",
    "--primary-color-footer-text": "#FFFFFF",
    "--sidebar-color-text": "#FFFFFF",
    "--order-again-button": "#F7941D",
    "--darkblue": "#333333",
    "--blue-text-color": "#000000",
    "--red-text-color": "#E5175E",
    "--red-button-color": "#E5175E",
    "--red-button-text-color": "#FFFFFF",
    "--dropdown-menu-background": "#FFF8F0",
    "--dropdown-menu-border": "#F7941D",
    "--dropdown-menu-color": "#333333",
    "--club-card-background-color": "rgba(244, 249, 252, 1)",
    "--club-card-price-color": "#F7941D",
    "--dropdown-background-color": "#FFFFFF",
    "--dropdown-border-color": "rgba(66, 61, 87, 1)",
    "--history-background-color": "#FFF8F0",
    "--scheduled-button-text-color": "#F7941D",
    "--available-room-color": "#F7941D",
    "--coach-name-color": "#959594",
    "--dialog-border-radius": "24px",
    "--font-family": `"OpenSans", sans-serif`,
    "--primary-gradient": "linear-gradient(to left, #E5175E, #F7941D)",
    "--dialog-secondary-btn-bg": "#FFFFFF",
    "--dialog-secondary-btn-color": "#333333",
    "--disabled-btn-bg": "transparent",
    "--disabled-btn-border": "#333333",
    "--disabled-btn-color": "#333333",
  },
};

const ThemeProvider = ({ children }) => {
  // resolvePartnerSync, not the bare selector: setPartner is dispatched from inside
  // silentLogin, so the store still reads NONE on the first render. Using it there
  // fell through to the Mehudet fallback below — theming a Clalit user in Mehudet's
  // colours and, worse, asking the browser for Mehudet's font, only to replace both
  // a moment later once the handshake landed.
  const partner = resolvePartnerSync(useSelector(selectPartner));

  // A layout effect, not a passive one: every --v2-* consumer is unstyled until these
  // land (var() with no fallback computes to unset, so backgrounds go transparent and
  // font-family falls back to the browser default). Passive effects run after paint,
  // which is exactly the unstyled frame this avoids. Nothing here touches the network,
  // so it is cheap enough to block paint on.
  useLayoutEffect(() => {
    const theme = themes[partner] || themes[PARTNER_KEYS.MEHUDET];
    // V2 redesign tokens (src/v2/theme/tokens.js) — additive, --v2-* namespace only.
    const v2Theme = v2Tokens[partner] || v2Tokens[PARTNER_KEYS.MEHUDET];

    Object.entries({ ...theme, ...v2Theme }).forEach(([property, value]) => {
      document.documentElement.style.setProperty(property, value);
    });
  }, [partner]);

  return <>{children}</>;
};

export default ThemeProvider;
